import entegrenzoLogoUrl from "../assets/images/EntegrenzoLogo.png";
import entegrenzoFaviconUrl from "../assets/images/EntegrenzoFavIcon.png";
import pazaryeriLogoUrl from "../assets/images/logooo.png";
import pazaryeriFaviconUrl from "../assets/images/pazaryeri_converter_logo.jpg";

const appName = import.meta.env.VITE_APP_NAME || "PazaryeriConverter";

const normalizeNameForNoSpace = (name) => name.replace(/\s+/g, "");

const isEntegrenzoBrand = (name) =>
  normalizeNameForNoSpace(name).toLowerCase() === "entegrenzo";

const defaultLogoUrl = isEntegrenzoBrand(appName)
  ? entegrenzoLogoUrl
  : pazaryeriLogoUrl;
const defaultFaviconUrl = isEntegrenzoBrand(appName)
  ? entegrenzoFaviconUrl
  : pazaryeriFaviconUrl;

/** /src/... only works with Vite dev server; production dist has no src folder. */
function resolveBrandingUrl(envValue, bundledUrl) {
  if (typeof envValue === "string" && envValue.trim() !== "") {
    if (envValue.startsWith("/src/")) return bundledUrl;
    return envValue;
  }
  return bundledUrl;
}

export const APP_CONFIG = {
  name: appName,
  nameNoSpace: normalizeNameForNoSpace(appName),
  logoUrl: resolveBrandingUrl(
    import.meta.env.VITE_APP_LOGO_URL,
    defaultLogoUrl
  ),
  faviconUrl: resolveBrandingUrl(
    import.meta.env.VITE_APP_FAVICON_URL,
    defaultFaviconUrl
  ),
};

